import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { DomainDataService } from '../../../../../../services';
import { FinanceCostPageService } from '../../../finance-cost.page.service';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';
import { TrimesterCost } from '@interfaces';


export function getSetup(pageService: FinanceCostPageService, util: UtilityService, domainDataService: DomainDataService): GridSetup<TrimesterCost> {
	return {
		rowName: { singular: 'Cost', plural: 'Costs' },
		getRowKey: row => '' + row.trimesterCostId,
		stateKey: 'finance-cost-trimester-grid',
		actions: getActions(),
		buttons: getButtons(),
		columns: getColumns(util, domainDataService),
		renderRowClasses: row => [],
		multiselect: false,
	}
}
